var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.958,
    height: 16.396,
    viewBox: "0 0 19.958 16.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "compare",
    transform: "translate(-3 -8.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8961",
    "data-name": "Path 8961",
    d: "M36.218,11.4H26.881L29.339,9.4a.688.688,0,1,0-.871-1.066l-3.953,3.23a.691.691,0,0,0-.082.982c.025.03.055.056.082.084l3.953,3.23a.688.688,0,1,0,.871-1.066l-2.459-2.009h9.337a.688.688,0,1,0,0-1.376Z",
    transform: "translate(-13.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8962",
    "data-name": "Path 8962",
    d: "M15.557,37.3a.69.69,0,0,0-.166-.861l-3.953-3.23a.688.688,0,1,0-.871,1.066l2.459,2.009H3.688a.688.688,0,1,0,0,1.376h9.337l-2.459,2.009a.688.688,0,1,0,.871,1.066l3.953-3.23a.768.768,0,0,0,.166-.205Z",
    transform: "translate(0 -16.317)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareWhite);
export default __webpack_public_path__ + "static/media/compare-white.c2809a809e877b995f291aba614b8715.svg";
export { ForwardRef as ReactComponent };